export const MESSAGES_PER_PAGE = 15;
export const CHAT_ID = 'chat';
